import * as Rx from 'rxjs'
import * as RxOperators from 'rxjs/operators'

export default class ElapsedTimeCounter {
  _onElapseSubject: Rx.Subject<number>
  _counterUpdateSubscription: Subscription

  constructor () {
    this._onElapseSubject = new Rx.Subject()
    this._counterUpdateSubscription = new Rx.Subscription()
  }

  start () {
    this._counterUpdateSubscription.unsubscribe()
    this._counterUpdateSubscription = Rx.interval(1000)
      .pipe(
        RxOperators.multicast(this._onElapseSubject)
      )
      .connect()
  }

  stop () {
    this._counterUpdateSubscription.unsubscribe()
  }

  onElapsedAsObservable (): Rx.Observable<number> {
    return this._onElapseSubject
  }
}
